// Returned format: dd.mm.yyyy
export function getCurrentDate() {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; // Months start at 0
  const yyyy = today.getFullYear();

  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }

  return `${dd}.${mm}.${yyyy}`;
}

export function getCurrentYear() {
  return new Date().getFullYear();
}